export function getLocalTimeString(offsetMilliseconds: number = 0) {
    const now = new Date();
    now.setMilliseconds(now.getMilliseconds() + offsetMilliseconds);

    // Get hours, minutes, and seconds
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds() + offsetMilliseconds).padStart(4, "0");

    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export function schedule(callback: Function) {
    setTimeout(callback, 100);
}

export const sleep = (time: number) => new Promise<void>(resolve => setTimeout(resolve, time));

export interface MeasureTimeOptions {
    cutoff?: number;
}

export function measureTime(
    optionsOrTarget?: MeasureTimeOptions | any,
    propertyKey?: string,
    descriptor?: PropertyDescriptor,
): any {
    // Called as @measureTime (direct decorator)
    if (propertyKey !== undefined && descriptor !== undefined) {
        return createMethodDecorator({})(optionsOrTarget, propertyKey, descriptor);
    }

    // Called as @measureTime() or @measureTime({ cutoff: 100 })
    const options = (optionsOrTarget as MeasureTimeOptions) || {};
    return createMethodDecorator(options);
}

function createMethodDecorator(options: MeasureTimeOptions = {}) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
        const originalMethod = descriptor.value;
        const cutoff = options?.cutoff;

        descriptor.value = function (...args: any[]) {
            const methodName =
                propertyKey === "execute"
                    ? `${target.constructor.name}.${propertyKey}(${args[0]})`
                    : `${target.constructor.name}.${propertyKey}`;

            const start = performance.now();

            const result = originalMethod.apply(this, args);

            const logElapsed = () => {
                const end = performance.now();
                const duration = end - start;
                if (!cutoff || duration > cutoff)
                    console.debug(`[PROFILE] ${methodName} executed in ${duration.toFixed(3)} ms.`);
            };

            if (result instanceof Promise) {
                return result.finally(() => logElapsed());
            } else {
                logElapsed();
                return result;
            }
        };

        return descriptor;
    };
}
